/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, EventEmitter, Input, OnInit, Output, inject, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { take } from 'rxjs/operators'
import { BaseFormControlComponent } from '../base-form-control.component'
import { DynamicFormLayout, DynamicFormLayoutService } from '../../../service/dynamic-form-layout.service'
import { DynamicFormControlLayout } from '../../../model/misc/dynamic-form-control-layout.model'
import { DynamicSelectModel } from '../../../model/select/dynamic-select.model'
import { DynamicFormValidationService } from '../../../service/dynamic-form-validation.service'

export enum DynamicBasicSelectMode {
  DEFAULT,
  SEARCH,
}

@Component({
  selector: 'dynamic-basic-select',
  templateUrl: './dynamic-basic-select.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DynamicBasicSelectComponent extends BaseFormControlComponent implements OnInit {
  declare layoutService: DynamicFormLayoutService
  declare validationService: DynamicFormValidationService

  @Input() declare formLayout: DynamicFormLayout
  @Input() declare group: UntypedFormGroup
  @Input() declare layout: DynamicFormControlLayout
  @Input() declare model: DynamicSelectModel<string>

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() blur: EventEmitter<any> = new EventEmitter()
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change: EventEmitter<any> = new EventEmitter()
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() focus: EventEmitter<any> = new EventEmitter()

  public DynamicBasicSelectMode = DynamicBasicSelectMode
  public mode = DynamicBasicSelectMode.DEFAULT
  public modelOptions: any

  constructor() {
    const layoutService = inject(DynamicFormLayoutService)
    const validationService = inject(DynamicFormValidationService)

    super()

    this.layoutService = layoutService
    this.validationService = validationService
  }

  public ngOnInit(): void {
    this.model.options$.pipe(take(1)).subscribe((options) => {
      this.modelOptions = options
      this.mode = options.length && options.length >= 5 ? DynamicBasicSelectMode.SEARCH : DynamicBasicSelectMode.DEFAULT
    })
  }
}
